  export class EstatusJSON{
     isSuccess : boolean;
     message : string;
     errors : Array<string>;
     result : any
    }